import { Component, Vue } from 'vue-facing-decorator';
import { User } from '@/types/User';
import { useGlobalStore } from '@/stores/useGlobalStore';

@Component
export default class AuthMixin extends Vue {
    doLoginUser(user: User): void {
        const globalStore = useGlobalStore();
        globalStore.mutationLoginUser(user);
    }

    doUnLoginUser(): void {
        const globalStore = useGlobalStore();
        globalStore.mutationUnLoginUser();
    }
}
